import styled from "styled-components";

export const CompareStickyWrapper = styled.div`
  position: fixed;
  left: 15px;
  z-index: 2;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  bottom: 50px;
  @media(min-width:768px){
    padding: 7px;
    margin: -7px;
    bottom: 130px;
  }
  @media(min-width:1200px){
    bottom: 150px;
  }
`;

export const StickyContent = styled.div`
  background: white;
  box-shadow: 0 6px 10px -2px #1b1f2733, 0 4px 74px #1b1f2759,
    0 0 0 6px rgb(0 0 0 / 10%);
  border-radius: 25px;
  display: flex;
  align-items: center;
  position: relative;
  height: 40px;
  @media(min-width:768px){
    height: 50px;
  }
  
  span {
    display:none;
    padding: 0 6px 0 20px;
  }

  i {
    position: absolute;
    top: -4px;
    right: -3px;
    padding: 1px 6px;
    background: #f11382;
    color: #fff;
    z-index: 2;
    border-radius: 50%;
    font-size: 12px;
    line-height: 18px;
    font-weight: 700;
    font-style: normal;
  }
`;

export const Thumbnail = styled.div`
  background: #cdd0d6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  overflow: hidden;
  justify-content: center;
  margin: 3px;
  padding: 3px;
  width: 36px;
  height: 36px;
  @media(min-width:768px){
    width: 46px;
    height: 46px;
  }
`;
